'use client'

import React from 'react'

type TextProps = {
  readonly text: string
  readonly type: 'h1' | 'h2' | 'h3' | 'h4' | 'p'
}

export default function Text({ text, type }: TextProps) {
  return React.createElement(type || 'p', { role: 'presentation' }, text)
}
